document.addEventListener('DOMContentLoaded', function () {
  function initFlyoutToggles() {
    const flyoutNav = document.querySelector('.localads-header-flyout__nav-list');
    if (!flyoutNav) return;

    // Add dropdown toggles and count badges to all menu items with children
    const menuItemsWithChildren = flyoutNav.querySelectorAll('.menu-item-has-children > a');

    menuItemsWithChildren.forEach((link) => {
      const parentItem = link.parentElement;

      // Skip if toggle already exists
      if (link.querySelector('.dropdown-toggle')) return;

      // Create dropdown toggle chevron
      const toggleBtn = document.createElement('span');
      toggleBtn.className = 'dropdown-toggle';
      link.appendChild(toggleBtn);

      // Count children and add badge
      let childCount = 0;
      if (parentItem.classList.contains('products-menu')) {
        // For products-menu, count mega-menu-mobile items
        const megaMenu = parentItem.querySelector('.mega-menu-mobile');
        if (megaMenu) {
          childCount = megaMenu.querySelectorAll('.mega-menu-mobile__item').length;
        }
      } else {
        // For regular menus, count sub-menu items
        const subMenu = parentItem.querySelector(':scope > .sub-menu');
        if (subMenu) {
          childCount = subMenu.querySelectorAll(':scope > .menu-item').length;
        }
      }

      if (childCount > 0) {
        const badge = document.createElement('span');
        badge.className = 'menu-item-badge';
        badge.textContent = childCount;
        // Insert badge before the toggle
        link.insertBefore(badge, toggleBtn);
      }

      // Toggle click handler
      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        // Close other open items at same level
        flyoutNav.querySelectorAll('.menu-item-has-children.open-flyout').forEach(item => {
          if (item !== parentItem) item.classList.remove('open-flyout');
        });

        parentItem.classList.toggle('open-flyout');
      });
    });
  }

  // Initialize on DOM load
  initFlyoutToggles();

  // Re-initialize when flyout opens
  const flyoutElement = document.querySelector('.localads-header-flyout');
  if (flyoutElement) {
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (flyoutElement.classList.contains('is-open')) {
            setTimeout(initFlyoutToggles, 50);
          }
        }
      });
    });
    observer.observe(flyoutElement, { attributes: true, attributeFilter: ['class'] });
  }
});
